import axios from 'axios'

export default axios.create({
    baseURL: 'https://react-quiz-7aa70.firebaseio.com/'
})